// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import {
  BallotOutlined,
  PlaceRounded,
} from '@/constants/hardfin-standard-icons';

export type AssetLocationReportGroup = 'location' | 'product';

export const ASSET_LOCATION_REPORT_GROUP_OPTIONS: FilterOption<AssetLocationReportGroup>[] =
  [
    {
      value: 'location',
      label: 'Location',
      icon: <PlaceRounded fontSize="small" />,
    },
    {
      value: 'product',
      label: 'Product',
      icon: <BallotOutlined fontSize="small" />,
    },
  ];
